export const recaptchaConfig = {
  sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
  secretKey: process.env.VUE_APP_RECAPTCHA_SECRET_KEY,
}